import { Component, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EventService } from 'src/app/admin/services/event.service';
import { AppUtils } from 'src/app/helpers/app.utils';
import { Subscription } from 'rxjs';
import { EventCalenderViewModel } from 'src/app/admin/models/event.calender.view.model';
import { PagedEventCalenderViewDetails } from 'src/app/admin/models/event.calender.view.detail.model';
import { TableModel } from 'src/app/models/table.model';
import { PagedResponseModel } from 'src/app/models/paged.response.model';
import { SelectListItemModel } from 'src/app/models/select.list.item.model';

@Component({
    selector: 'app-image-event-selector',
    templateUrl: './image.event.selector.component.html',
    styleUrls: ['./image.event.selector.component.scss']
})

export class ImageEventSelectorComponent implements OnDestroy {
    @ViewChild('eventSelectedWithModal', null) modalContent: any;
    @Output() eventSelected = new EventEmitter<any>();
    eventId: number;
    modalRef: NgbModalRef;
    buyers = new Array<any>();
    selectedView: number;

    subscriptions = new Array<Subscription>();
    pagedYearDetails = new PagedEventCalenderViewDetails();
    months = new Array<EventCalenderViewModel>();
    yearTotalRecords = 0;
    yearTableModel = new TableModel();
    isModelLoaded = false;
    selectedYear: number;
    selectedMonth: number;
    selectedEvent: any;

    pagedEvents = new PagedResponseModel<SelectListItemModel>();
    tableModel = new TableModel();
    totalRecords = 0;
    isPremium = false;

    constructor(private ngxSpinner: NgxSpinnerService,
        private router: Router,
        private modalService: NgbModal,
        private spinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private eventService: EventService) {
        this.initYearSubscribers();
        this.initSubscribers();
        this.yearTableModel.pageSize = 6;
        this.tableModel.pageSize = 10;
    }

    openModal(selectedView: number) {
        this.modalRef = this.modalService.open(this.modalContent);
        this.selectedView = selectedView;
        this.getYears();
        return this.modalRef;
    }

    initYearSubscribers() {
        const subscription = this.yearTableModel.pageChanged.subscribe(() => this.getYears());
        this.subscriptions.push(subscription);
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getEvents());
        this.subscriptions.push(subscription);
    }

    getYears = () => {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.eventService.yearList(this.yearTableModel)
            .subscribe(data => {
                Object.assign(this.pagedYearDetails, data);
                this.yearTotalRecords = data.totalCount;
                this.yearTableModel.totalPages = data.totalPages;
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    getMonths = (year: number) => {
        this.isModelLoaded = false;
        this.selectedYear = year;
        this.ngxSpinner.show();
        this.eventService.monthList(year)
            .subscribe(data => {
                Object.assign(this.months, data);
                this.months.forEach(month => {
                    month.monthInNumber = month.name;
                    month.name = AppUtils.getMonthName(month.name);
                });
                this.ngxSpinner.hide();
                this.selectedView = 1;
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    monthChanged(month: number) {
        this.selectedMonth = month;
        this.tableModel.startDate = AppUtils.getStartDate(month, this.selectedYear);
        this.tableModel.endDate = AppUtils.getEndDate(month, this.selectedYear);
        this.getEvents();
    }

    search() {
        this.getEvents();
    }

    reset() {
        this.selectedYear = null;
        this.selectedMonth = null;
        this.tableModel.startDate = '';
        this.tableModel.endDate = '';
        this.selectedView = 0;
        this.tableModel.filterKey = '';
        this.yearTableModel.page = 1;
        this.getYears();
    }

    getEvents = () => {
        this.isModelLoaded = false;
        this.selectedView = 2;
        this.ngxSpinner.show();
        this.eventService.getPagedSelectItems(this.tableModel)
            .subscribe(data => {
                Object.assign(this.pagedEvents, data);
                this.totalRecords = data.totalCount;
                this.tableModel.totalPages = data.totalPages;
                this.ngxSpinner.hide();
                this.selectedView = 2;
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    goToPrevView() {
        switch (this.selectedView) {
            case 1:
                this.selectedYear = null;
                this.tableModel.startDate = '';
                this.tableModel.endDate = '';
                this.selectedView = 0;
                break;
            case 2:
                this.selectedMonth = null;
                this.tableModel.startDate = '';
                this.tableModel.endDate = '';
                this.selectedView = 1;
                break;
        }
    }

    submit() {
        this.eventSelected.next(this.selectedEvent);
        this.modalRef.close();
    }

    closeModal() {
        this.reset();
        this.modalRef.close();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
}
